//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { date } from 'quasar'
import { required } from 'vuelidate/lib/validators'
// 解构只保留需要的东西
const { addToDate } = date

const stringOptions = [
  'Google', 'Facebook', 'Twitter', 'Apple', 'Oracle'
]
const conOrderPayAccountOptions = [
  '账户郭强', '账户渠静', '对公账户', '业务员微信', '业务员支付宝'
]
const stringCompanys = [
  { label: '贝克巴斯', value: 'BKBS' },
  { label: '思维思通', value: '3M' },
  { label: '亿瞳', value: '亿瞳' }
]
const conTfOptions = [
  { label: '否', value: '0' },
  { label: '是', value: '1' }
]
const columns = [
  { name: 'name', label: '产品', field: 'name', required: true },
  { name: 'take', label: '带机', field: 'take' },
  { name: 'num', label: '数量', field: 'num' },
  { name: 'price', label: '单价', field: 'price' },
  { name: 'id', label: '操作', field: 'id' }
]
const ocolumns = [
  { name: 'parts_name', label: '产品', field: 'parts_name', required: true },
  { name: 'usedNum', label: '数量', field: 'usedNum' },
  { name: 'name', label: '用户', field: 'name' },
  { name: 'mobile', label: '电话', field: 'mobile' },
  { name: 'number', label: '单号', field: 'number' },
  { name: 'id', label: '操作', field: 'id' }
]
const orcolumns = [
  { name: 'title', label: '产品信息', field: 'title' },
  { name: 'name', label: '用户', field: 'name' },
  { name: 'mobile', label: '电话', field: 'mobile' },
  { name: 'salesman', label: '业务员', field: 'salesman' },
  { name: 'number', label: '单号', field: 'number' },
  { name: 'id', label: '操作', field: 'id' }
]

const workerCollectionTypes = [
  { value: 0, label: '无需交款' },
  { value: 1, label: '代收款交业务' },
  { value: 2, label: '代收款交公司' }
]
export default {
  components: {
    date, required
  },
  data() {
    return {
      form: {
        type: 1,
        company: stringCompanys[0],
        service: null,
        saleman: null,
        channel: null,
        channelNumber: null,
        store: null,
        userProvince: null,
        userCity: null,
        userArea: null,
        userName: '',
        userPhone: '',
        userMobile: '',
        userAddress: '',
        newUserProvince: null,
        newUserCity: null,
        newUserArea: null,
        newUserName: '',
        newUserPhone: '',
        newUserMobile: '',
        newUserAddress: '',
        products: [],
        oProducts: [],
        isCreateAsfOrder: '否',
        workerCollectionType: '',
        workerCollectionAmount: 0,
        dispatchDate: null,
        relOrderIds: [],
        relOrderNumbers: [],
        isNeedInvoice:'否',
        isOrderPay:'否',
        isSendDelivery:'否',
        invoiceTitle:'',
        invoiceAddress:'',
        deliveryNumber:'',
        orderPayAccount:'',
        userProjectName:'',
        userProjectManager:'',
        position:''
      },
      
      tfOptions:conTfOptions,
      orderPayAccountOptions:conOrderPayAccountOptions,
      orders:[],
      showProducts: false,
      showOProducts: false,
      showOrders:false,
      showNewUser:false,
      showOrderNumberInput:true,
      showStoreInput:true,
      showOtherInfo:true,
      title: '',
      loading4: false,
      orderType: 1,
      provinceId: 0,
      cityId: 0,
      areaId: 0,
      text: null,
      companyOptions: stringCompanys,
      serviceOptions: null,
      channelOptions: [],
      salemanOptions: [],
      salemanAllData: [],
      servicesAllData: [],
      serviceOptions: [],
      storeOptions: [],
      storeAllData: [],
      provinceOptions: [],
      provinceAllData: [],
      cityOptions: [],
      cityAllData: [],
      areaOptions: [],
      areaAllData: [],
      mobileModel: null,
      mobileOptions: [],
      newProvinceOptions: [],
      newCityOptions: [],
      newAreaOptions: [],
      newMobileModel: null,
      newMobileOptions: [],
      model: null,
      productTabelColumns: columns,
      oProductTabelColumns: ocolumns,
      orderTabelColumns: orcolumns,
      productOptions: [],
      oProductOptions: [],
      orderOptions: [],
      productModel: null,
      orderModel: null,
      isCreateAsfOrderOptions: ['否', '是'],
      workerCollectionTypeOptions: workerCollectionTypes,
      options: stringOptions
    }
  },
  validations: {
    form: {
      userName: { required }
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    let type = this.$route.params.type
    this.form.type = parseInt(type)
    console.log(this.form.type)
    let title = '';
    var titleMap = {
      1: '创建正常终端订单',2: '创建代理商订单', 21: '创建电商订单',6: '创建样机订单', 4: '创建私单转终端订单', 44: '创建退货订单', 5: '创建赠送订单',9:'创建批发订单',7:'创建赔偿订单'
    }
    this.title = title = titleMap[type]
    console.log(title)
    if (type == 1 || type == 2 || type == 6 ||type == 7 || type==5 || type==9 || type==10||type==21) {
      this.showProducts = true;
    } 
    if (type == 4||type==44) {
      this.showOProducts = true;
    }
     if(type==5||type==7){
       this.showOrders = true
     }
     if(type==9||type==2||type==21){
       this.showNewUser = true;
     }
     if(type==7){
       this.showOrderNumberInput = false
      }
      if(type==2||type==21){
        this.showOtherInfo = false
       this.showStoreInput = false
     }

    this.$axios
      .get('/api/beijing/salemanList')
      .then((response) => (this.salemanAllData = this.salemanOptions = response.data.data))
      .catch(function (error) { // 请求失败处理
        console.log(error);
      });

    this.$axios
      .get('/api/beijing/storeList')
      .then((response) => (this.storeAllData = this.storeOptions = response.data.data))
      .catch(function (error) { // 请求失败处理
        console.log(error);
      });

    this.$axios
      .get('/api/beijing/serversList?orderType=' + this.orderType)
      .then((response) => (this.servicesAllData = this.serviceOptions = response.data.data))
      .catch(function (error) { // 请求失败处理
        console.log(error);
      });

    //省份
    this.$axios
      .get('/api/city/info?from=quasar')
      .then((response) => (this.provinceAllData = this.provinceOptions = this.newProvinceOptions = response.data.data))
      .catch(function (error) { // 请求失败处理
        console.log(error);
      });
  },
  methods: {
    filterChannel(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        const company = this.form.company.value
        console.log(needle, company);
        this.$axios
          .get('/api/beijing/channelList?channelName=' + needle + "&company=" + company)
          .then((response) => (this.channelOptions = response.data.data))
          .catch(function (error) { // 请求失败处理
            console.log(error);
          });
      })
    },
    filterMobile(val, update, abort) {
      update(() => {
        const needle = encodeURIComponent(val.toLowerCase())
        this.$axios
          .get('/api/beijing/user/searchAjax?from=quasar&q=' + needle)
          .then((response) => (this.mobileOptions = response.data.data))
          .catch(function (error) { // 请求失败处理
            console.log(error);
          });
      })
    },
    filterNewMobile(val, update, abort) {
      update(() => {
        const needle = encodeURIComponent(val.toLowerCase())
        this.$axios
          .get('/api/beijing/user/searchAjax?from=quasar&q=' + needle)
          .then((response) => (this.newMobileOptions = response.data.data))
          .catch(function (error) { // 请求失败处理
            console.log(error);
          });
      })
    },
    filterProduct(val, update, abort) {
      update(() => {
        const needle = encodeURIComponent(val.toLowerCase())
        const company = this.form.company.value
        console.log(needle, company);
        this.$axios
          .get('/api/beijing/product/searchAjax?from=quasar&q=' + needle + "&company=" + company)
          .then((response) => (this.productOptions = response.data.data))
          .catch(function (error) { // 请求失败处理
            console.log(error);
          });
      })
    },
    onProductChange(val) {
      console.log("onProductChange", val.label, val.value);
      var has = false;
      for (var i = 0; i < this.form.products.length; i++) {
        if (this.form.products[i]['id'] == val.value) {
          has = true;
          break;
        }
      }
      if (!has) {
        let product = {
          name: val.label,
          id: val.value,
          num: 1,
          price: 0,
          take: '是'
        }
        this.form.products.push(product);
        console.log(this.form.products)
      }
    },
    delProductFun(val) {
      console.log("delProductFun", val);
      for (var i = 0; i < this.products.length; i++) {
        if (this.form.products[i]['id'] == val) {
          this.form.products.splice(i, 1);
          break;
        }
      }
    },
    filterOProduct(val, update, abort) {
      update(() => {
        const needle = encodeURIComponent(val.toLowerCase())
        const company = this.form.company.value
        console.log(needle, company);
        let url = '/api/beijing/productOrder/productList?mustFinish=1&from=select&types=1,2,21,5,6,3,7,9,10,22,100&page=1&rows=10&keyword=' + needle
        console.log(url)
        this.$axios
          .get(url)
          .then((response) => (this.oProductOptions = response.data.rows))
          .catch(function (error) { // 请求失败处理
            console.log(error);
          });
      })
    },
    onOProductChange(val) {
      console.log("onProductChange", val.label, val.value);
      var has = false;
      for (var i = 0; i < this.form.oProducts.length; i++) {
        if (this.form.oProducts[i]['id'] == val.id) {
          has = true;
          break;
        }
      }
      if (!has) {
        val.usedNum = 1
        let oproduct = val
        this.form.oProducts.push(oproduct);
        this.form.relOrderIds.push(val['order_id'])
        this.form.relOrderNumbers.push(val['number'])
        console.log(this.form.oProducts)
      }
    },
    delOProductFun(val) {
      console.log("delOProductFun", val);
      this.form.relOrderIds = [];
      this.form.relOrderNumbers = [];
      for (var i = 0; i < this.form.oProducts.length; i++) {
        if (this.form.oProducts[i]['id'] == val) {
          this.form.oProducts.splice(i, 1);
        } else {
          let item = this.form.oProducts[i]
          this.form.relOrderIds.push(item['order_id'])
          this.form.relOrderNumbers.push(item['number'])
        }
      }
    },
    filterOrder(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        const company = this.form.company.value
        console.log(needle, company);
        this.$axios
          .get('/api/beijing/productOrder/list?types=1,2,22,100&from=&statusEq=0&page=1&rows=20&kk=' + needle)
          .then((response) => (this.orderOptions = response.data.rows))
          .catch(function (error) { // 请求失败处理
            console.log(error);
          });
      })
    },
    onOrderChange(val) {
      console.log("onOrderChange", val.label, val.value);
      var has = false;
      for (var i = 0; i < this.orders.length; i++) {
        if (this.orders[i]['id'] == val.id) {
          has = true;
          break;
        }
      }
      if (!has) {
        let order = val
        this.orders.push(order);
        this.form.relOrderIds.push(val['order_id'])
        this.form.relOrderNumbers.push(val['number'])
        console.log(this.orders)

        this.form.userMobile = val.mobile;
        this.form.userName = val.name;
        this.form.userPhone = val.phone;
        this.form.userProvince = { value: val.province_id, label: val.provinceName }
        this.form.userCity = { value: val.city_id, label: val.cityName }
        this.form.userArea = { value: val.area_id, label: val.areaName }
        this.form.userAddress = val.address
        this.form.saleman = val.salesman
        this.form.store = val.store

      }
    },
    delOrderFun(val) {
      console.log("delOrderFun", val);
      this.form.relOrderIds = [];
      this.form.relOrderNumbers = [];
      for (var i = 0; i < this.orders.length; i++) {
        if (this.orders[i]['id'] == val) {
          this.orders.splice(i, 1);
        } else {
          let item = this.orders[i]
          this.form.relOrderIds.push(item['order_id'])
          this.form.relOrderNumbers.push(item['number'])
        }
      }
    },
    filterSaleman(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.salemanOptions = this.salemanAllData.filter(v => v.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterStore(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.storeOptions = this.storeAllData.filter(v => v.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterProvince(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.provinceOptions = this.provinceAllData.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
    filterNewProvince(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.newProvinceOptions = this.provinceAllData.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
    onMobileChange(val) {
      console.log(val)
      this.form.userMobile = val.mobile;
      this.form.userName = val.name;
      this.form.userPhone = val.phone;
      this.form.userProvince = { value: val.province_id, label: val.provinceName }
      this.form.userCity = { value: val.city_id, label: val.cityName }
      this.form.userArea = { value: val.area_id, label: val.areaName }
      this.form.userAddress = val.address
    },
    onNewMobileChange(val) {
      console.log(val)
      this.form.newUserMobile = val.mobile;
      this.form.newUserName = val.name;
      this.form.newUserPhone = val.phone;
      this.form.newUserProvince = { value: val.province_id, label: val.provinceName }
      this.form.newUserCity = { value: val.city_id, label: val.cityName }
      this.form.newUserArea = { value: val.area_id, label: val.areaName }
      this.form.newUserAddress = val.address
    },
    onProvinceChange(val) {
      console.log("onProvinceChange", val.label, val.value);
      this.form.userCity = null;
      this.cityAllData = [];
      this.cityOptions = [];
      this.form.userArea = null;
      this.areaAllData = [];
      this.areaOptions = [];
      this.$axios
        .get('/api/city/info?from=quasar&pid=' + val.value)
        .then((response) => (this.cityAllData = this.cityOptions = response.data.data))
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    filterCity(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.cityOptions = this.cityAllData.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
    onCityChange(val) {
      this.form.userArea = null;
      this.areaAllData = [];
      this.areaOptions = [];
      this.$axios
        .get('/api/city/info?from=quasar&pid=' + val.value)
        .then((response) => (this.areaAllData = this.areaOptions = response.data.data))
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    filterArea(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.areaOptions = this.areaAllData.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
    onNewProvinceChange(val) {
      console.log("onNewProvinceChange", val.label, val.value);
      this.form.newUserCity = null;
      this.cityAllData = [];
      this.newCityOptions = [];
      this.form.newUserArea = null;
      this.areaAllData = [];
      this.newAreaOptions = [];
      this.$axios
        .get('/api/city/info?from=quasar&pid=' + val.value)
        .then((response) => (this.cityAllData = this.newCityOptions = response.data.data))
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    filterNewCity(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.newCityOptions = this.cityAllData.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
    onNewCityChange(val) {
      this.form.userArea = null;
      this.areaAllData = [];
      this.areaOptions = [];
      this.$axios
        .get('/api/city/info?from=quasar&pid=' + val.value)
        .then((response) => (this.areaAllData = this.newAreaOptions = response.data.data))
        .catch(function (error) { // 请求失败处理
          console.log(error);
        });
    },
    filterNewArea(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.newAreaOptions = this.areaAllData.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
    simulateProgress(number) {
      console.log('submit')
      console.log(this.form);
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        this.$q.notify('请检查资料是否输入完整')
        return
      }
      var that = this;
      // we set loading state
      this[`loading${number}`] = true
      var data = this.form;
      let type = this.$route.params.type
      if(type==5){
        data.orders=[]
      }

      this.$axios({
        url: '/api/beijing/productOrder/editAjaxForMobi',
        method: 'post',
        data: JSON.stringify(data),
        header: {
          'Content-Type': 'application/json'  //如果写成contentType会报错
        }
      })
        .then(res => {
          console.log(res.data)
          this[`loading${number}`] = false
          if (res.data.status == 0) {
            that.showSuccess()
            this.$router.push('/home')
          }else{
            that.showError(res.data.errmsg)
          }
        })
        .catch(Error => {
          console.log(Error)
          this[`loading${number}`] = false
        })

    },
    dispatchDateOptionFun(d) {
      let newDate = addToDate(new Date(), { days: 1 })
      let startDate = date.formatDate(newDate, 'YYYY/MM/DD')
      return d > startDate
    },
    showSuccess() {
      this.$q.notify({
        message: '提示',
        caption: '操作成功',
        color: 'secondary'
      })
    },
    showError(msg) {
      this.$q.dialog({
        title: '出错了',
        message: msg
      }).onOk(() => {
        // console.log('OK')
      }).onCancel(() => {
        // console.log('Cancel')
      }).onDismiss(() => {
        // console.log('I am triggered on both OK and Cancel')
      })
    }
  }
}
